module.exports = __webpack_public_path__ + "img/img01.fd3a7e00.png";